import firebase, {database} from '../firebase'
import * as constants from '../Constatnts'
import axios from 'axios';

export function getSMSTemplatesByModule(registrationID, module) {
  return async (dispatch, getState) => {
    try {
      const token = getState().user.uat;
      const response = await axios.get(
        `${constants.API_URL}/setup/getSMSTemplatesByModule/${getState().user.store.key}/${module}`,
        {
          headers: {
            Authorization: `Bearer ${token}`,
          },
        }
      );
      return response.data.data;
    } catch (error) {
      console.error("API Error:", error);
      throw error;
    }
  };
}



export function getSMSTemplates(registrationID) {
  return async (dispatch, getState) => {
    try {
      const token = getState().user.uat;
      const response = await axios.get(
        `${constants.API_URL}/setup/transactionaltemplate`,
        {
          headers: {
            Authorization: `Bearer ${token}`,
          },
        }
      );
      return response.data.TransactionalSMSTemplates;
    } catch (error) {
      console.error("API Error:", error);
      throw error;
    }
  };
}



// // export function getSMSTemplatesByModule(registrationID, module){
// //     return (dispatch) => {
// //         return database.collection("SMSTemplates").where("RegistrationID", "==", registrationID).where("Module","==", module).where("IsDeleted", "==", false).orderBy("Name","asc").get().then((querySnapshot) => {
// //           let smsTemplates = []
// //           querySnapshot.forEach((doc) => {
// //             smsTemplates.push({ key: doc.id, ...doc.data() });
// //           });
// //           //console.log("getSMSTemplates", JSON.stringify(smsTemplates));
// //           return smsTemplates;
// //         });
// //       }
// // }

// // export function getSMSTemplatesBySMSType(registrationID, smsType){
// //     return (dispatch) => {
// //         return database.collection("SMSTemplates").where("RegistrationID", "==", registrationID).where("SMSType","==", smsType).where("Status","==","Approved").where("IsDeleted", "==", false).orderBy("Name","asc").get().then((querySnapshot) => {
// //           let smsTemplates = []
// //           querySnapshot.forEach((doc) => {
// //             smsTemplates.push({ key: doc.id, ...doc.data() });
// //           });
// //           console.log("getSMSTemplates", JSON.stringify(smsTemplates));
// //           return smsTemplates;
// //         });
// //       }
// // }

// // export function getSMSTemplates(registrationID, storeID)
// // {
// //     return (dispatch, getState) => {
// //         let q = database.collection("SMSTemplates").where("RegistrationID","==",registrationID)
// //         if(getState().user.user.Role === "Store Owner" && storeID.trim()!=="")
// //         {
// //             q.where("StoreID","==",storeID)
// //         }
// //         return q.get().then((querySnapshot) => {
// //             const smsTemplates = []
// //             querySnapshot.forEach((doc) => {
// //                 smsTemplates.push(
// //                   {
// //                     key:doc.id,...doc.data()
// //                   })
// //            })
// //             return smsTemplates
// //         }).catch((error) => {console.log(error)})
// //     }
// // }

// export function getSMSTemplatesByModule(registrationID, module){
//     return (dispatch, getState) => {
//         // return database.collection("SMSTemplates").where("StoreID", "==", registrationID).where("Module","==", module).where("IsDeleted", "==", false).orderBy("Name","asc").get().then((querySnapshot) => {
//         //   let smsTemplates = []
//         //   querySnapshot.forEach((doc) => {
//         //     smsTemplates.push({ key: doc.id, ...doc.data() });
//         //   });
//         //   //console.log("getSMSTemplates", JSON.stringify(smsTemplates));
//         //   return smsTemplates;
//         // });
//         let q = database.collection("SMSTemplates").where("RegistrationID","==",registrationID).where("Module","==", module).where("StoreID","==",getState().user.store.key.trim())
//         return q.get().then((querySnapshot) => {
//             const smsTemplates = []
//             querySnapshot.forEach((doc) => {
//                 smsTemplates.push(
//                   {
//                     key:doc.id,...doc.data()
//                   })
//            })
//             return smsTemplates
//         }).catch((error) => {console.log(error)})

//       }
// }

// export function getSMSTemplatesBySMSType(registrationID, smsType){
//     return (dispatch, getState) => {
//         // return database.collection("SMSTemplates").where("RegistrationID", "==", registrationID).where("SMSType","==", smsType).where("Status","==","Approved").where("IsDeleted", "==", false).orderBy("Name","asc").get().then((querySnapshot) => {
//         //   let smsTemplates = []
//         //   querySnapshot.forEach((doc) => {
//         //     smsTemplates.push({ key: doc.id, ...doc.data() });
//         //   });
//         //   console.log("getSMSTemplates", JSON.stringify(smsTemplates));
//         //   return smsTemplates;
//         // });

//         //let q = database.collection("SMSTemplates").where("RegistrationID","==",registrationID).where("SMSType","==", smsType).where("StoreID", "==", getState().user.store.key);
        
//         let q = database.collection("SMSTemplates").where("RegistrationID","==",registrationID).where("SMSType","==", smsType).where("StoreID", "==", getState().user.store.key).where("Status","==","Approved").where("IsDeleted", "==", false).orderBy("Name","asc");
//         return q.get().then((querySnapshot) => {
//             const smsTemplates = []
//             querySnapshot.forEach((doc) => {
//                 smsTemplates.push(
//                   {
//                     key:doc.id,...doc.data()
//                   })
//            })
//             return smsTemplates
//         }).catch((error) => {console.log(error)})

//       }
// }

// export function getSMSTemplates(registrationID, storeID)
// {
//     return (dispatch, getState) => {
//         let q = database.collection("SMSTemplates").where("RegistrationID", "==", registrationID).where("StoreID", "==", getState().user.store.key)
        
//         return q.get().then((querySnapshot) => {
//             const smsTemplates = []
//             querySnapshot.forEach((doc) => {
//                 smsTemplates.push(
//                   {
//                     key:doc.id,...doc.data()
//                   })
//            })
//             return smsTemplates
//         }).catch((error) => {console.log(error)})
//     }
// }

export function saveSMSTemplate(smsTemplate, key) {
  return async (dispatch, getState) => {
    try {
      const token = getState().user.uat;
      let response = {};

      if (key !== "") {
        // Update existing account
        response = await axios.put(
          `${constants.API_URL}/setup/transactionaltemplate/${key}`,
          smsTemplate,
          {
            headers: {
              Authorization: `Bearer ${token}`,
            },
          }
        );
      } else {
        // Create new account
        response = await axios.post(
          `${constants.API_URL}/setup/transactionaltemplate/`,
          smsTemplate,
          {
            headers: {
              Authorization: `Bearer ${token}`,
            },
          }
        );
      }

      if (response.data.code === "0") {
        if (key) {
          return key;
        } else {
          return response.data.data.key;
        }
      }

      return null;
    } catch (error) {
      console.error("API Error:", error);
      throw error;
    }
  };
}


export function deleteSMSTemplate(key){
  return async (dispatch, getState) => {
    try {
      const token = getState().user.uat;
      const response = await axios.delete(
        `${constants.API_URL}/setup/transactionaltemplate/${key}`,
        {
          headers: {
            Authorization: `Bearer ${token}`,
          },
        }
      );
      if(response.data.code=="0"){
        return true
      }
      else{
        return false
      }
    } catch (error) {
      console.error("API Error:", error);
      throw error;
    }
  };
}


export function getSMSTemplateDetails(key) {
  return async (dispatch, getState) => {
    try {
      const token = getState().user.uat;
      const response = await axios.get(
        `${constants.API_URL}/setup/smstemplate/${key}`,
        {
          headers: {
            Authorization: `Bearer ${token}`,
          },
        }
      );
      return response.data.data;
    } catch (error) {
      console.error("API Error:", error);
      throw error;
    }
  };
}




